import { Link, useLocation as useRouterLocation } from "react-router-dom";
import { useCart } from "../state/CartContext";
import { useLang } from "../lib/useLang";
import { Money } from "./Money";

/** Floating cart bar on the storefront (hidden at count 0 and on cart/checkout). */
export function StickyCartBar() {
  const { count, subtotal } = useCart();
  const { t } = useLang();
  const { pathname } = useRouterLocation();

  const hidden =
    count === 0 ||
    pathname === "/cart" ||
    pathname === "/checkout" ||
    pathname.startsWith("/confirmation");
  if (hidden) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <Link
        to="/cart"
        className="pointer-events-auto mx-auto flex max-w-md items-center justify-between rounded-2xl bg-brand px-4 py-3 text-cream shadow-raised transition active:scale-[.99]"
      >
        <span className="font-semibold">
          🛒 {count} · {t("common.viewCart")}
        </span>
        <Money value={subtotal} className="font-bold" />
      </Link>
    </div>
  );
}
